import styled, { css } from "styled-components";
import { ReactNode } from "react";

interface IconButtonProps {
  icon?: ReactNode;
  isActive?: boolean;
}

const IconButton = ({ icon, isActive, ...props }: IconButtonProps) => {
  return (
    <Wrapper $isActive={isActive} {...props}>
      {icon}
    </Wrapper>
  );
};

export default IconButton;

const hoverStyles = css`
  background: ${(p) => p.theme.colors.blues[0]};
  color: ${(p) => p.theme.colors.primaryBlue};
`;
const Wrapper = styled.div<{ $isActive?: boolean }>`
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  padding: 8px;
  transition: color 0.25s, background-color 0.45s;
  ${(p) => p.$isActive && hoverStyles};
  &:hover {
    ${hoverStyles}
  }
`;
